import React from "react";
import Main from "./main.js";

const App = () => {
  return <Main />;
};
export default App;
